import { API as CorpAPI } from '@libs/shared';

export const API = CorpAPI;
